import React from "react"

import "../../styles/Common/GenericComponenetHeader.less"
export default function GenericComponenetHeader({
  BHTTitle = "BHTTitle",
  BHTContainer = "BHTContainer",
  BHTarrowStyle = "BHTarrowStyle",
  ...props
}) {
  return (
    <div className={BHTContainer}>
      <div className={BHTTitle + ' slide-right delay04'}  onClick={props.onClick} dangerouslySetInnerHTML={{__html: props.content.title}} />
    </div>
  )
}
